import { Box, IconButton } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import {
  useGridApiContext,
  type GridRenderCellParams,
} from "@mui/x-data-grid-pro";

const DEFAULT_TOGGLE_SLOT_WIDTH = 28;

export interface InlineTreeToggleCellProps {
  params: GridRenderCellParams;
  /** Accessible label for the toggle button while the group is collapsed. */
  expandLabel?: string;
  /** Accessible label for the toggle button while the group is expanded. */
  collapseLabel?: string;
  /** Width of the reserved toggle slot, in pixels. */
  toggleSlotWidth?: number;
}

export function InlineTreeToggleCell({
  params,
  expandLabel = "Expand",
  collapseLabel = "Collapse",
  toggleSlotWidth = DEFAULT_TOGGLE_SLOT_WIDTH,
}: Readonly<InlineTreeToggleCellProps>) {
  const apiRef = useGridApiContext();
  const { id, rowNode, value } = params;
  const isGroup = rowNode.type === "group";
  const expanded = isGroup && rowNode.childrenExpanded;

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", width: "100%", minWidth: 0 }}
    >
      <Box
        sx={{
          width: toggleSlotWidth,
          flexShrink: 0,
          display: "flex",
          justifyContent: "center",
        }}
      >
        {isGroup && (
          <IconButton
            size="small"
            aria-label={expanded ? collapseLabel : expandLabel}
            onClick={(event) => {
              event.stopPropagation();
              apiRef.current.setRowChildrenExpansion(id, !expanded);
            }}
          >
            {expanded ? (
              <KeyboardArrowUpIcon fontSize="small" />
            ) : (
              <KeyboardArrowDownIcon fontSize="small" />
            )}
          </IconButton>
        )}
      </Box>
      <Box
        component="span"
        sx={{
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "nowrap",
        }}
      >
        {value as string}
      </Box>
    </Box>
  );
}
